import { BadgeSlotProps, IconSlotProps } from '../types'
import { ColorEnum } from '@/constants/color'
import { FontEnum } from '@/constants/font'
import { ComponentType, FC } from 'react'
import { StyleProp, Text, View, ViewStyle } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface MenuItemProps {
    Icon: ComponentType<IconSlotProps>
    label: string
    active: boolean
    Badge?: ComponentType<BadgeSlotProps>
    style?: StyleProp<ViewStyle>
}

const MenuItem: FC<MenuItemProps> = ({ Icon, label, active, Badge, style }) => {
    const { styles } = useStyles(stylesheet, { active })

    return (
        <View style={[styles.container, style]}>
            <View style={styles.iconContainer}>
                <Icon size={24} />
                {Badge && <Badge active={active} style={styles.badge} />}
            </View>
            <Text style={styles.label}>{label}</Text>
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
    },
    iconContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 4,
        height: 32,
        width: 32,
        variants: {
            active: {
                true: {
                    backgroundColor: ColorEnum.BRICK_600,
                },
                false: {
                    backgroundColor: ColorEnum.Transparent,
                },
            },
        },
    },
    label: {
        fontFamily: FontEnum.SatoshiBold,
        fontSize: 10,
        letterSpacing: 0.5,
        textTransform: 'uppercase',
        variants: {
            active: {
                true: {
                    color: ColorEnum.BRICK_500,
                },
                false: {
                    color: ColorEnum.WHITE,
                },
            },
        },
    },
    badge: {
        position: 'absolute',
        right: -5,
        top: -5,
    },
})

export default MenuItem
